import { Link } from "react-router-dom";

export default function SafeShopping() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-4 whitespace-nowrap">
            Segurança
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Compras Seguras com CSSBuy Spreadsheet
          </h2>
          <p className="mt-3 text-foreground-500 text-sm max-w-2xl mx-auto">
            Nosso CSSBuy Spreadsheet prioriza a segurança em cada etapa do processo de compra internacional.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {[
            {
              icon: "ri-shield-check-line",
              title: "Links Verificados",
              desc: "Todos os links em nossa planilha são verificados manualmente antes de serem publicados. Removemos links quebrados e de vendedores não confiáveis diariamente.",
            },
            {
              icon: "ri-camera-line",
              title: "Fotos de Qualidade",
              desc: "Recomendamos sempre solicitar fotos de controle de qualidade (QC) no CSSBuy antes do envio. Nossa planilha indica quais vendedores oferecem QC gratuito.",
            },
            {
              icon: "ri-secure-payment-line",
              title: "Proteção ao Comprador",
              desc: "O CSSBuy oferece proteção ao comprador em todas as transações. Se o produto não corresponder à descrição, você tem direito a reembolso ou troca.",
            },
            {
              icon: "ri-ship-line",
              title: "Envio Seguro",
              desc: "Guia completo sobre as melhores opções de envio para o Brasil, incluindo linhas tax-free e triangle shipping para maior proteção alfandegária.",
            },
          ].map((item) => (
            <div key={item.title} className="bg-background-50 rounded-2xl p-6 hover:bg-background-50 transition-colors">
              <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-primary-600 text-xl`}></i>
              </div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">{item.title}</h4>
              <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/compras-seguras"
            className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 text-sm font-medium whitespace-nowrap cursor-pointer"
          >
            Guia completo de compras seguras
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}